import { useSetRecoilState } from "recoil";
import { outcomeCommentAtom } from "../miscellaneous/outcomeCommentAtom";

export const useSetOutcomeComment = () => {
  return useSetRecoilState(outcomeCommentAtom);
};
